import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Collapse,
  Button,
  ListItemIcon,
} from "@mui/material";
import {
  Menu as MenuIcon,
  ExpandLess,
  ExpandMore,
  Logout,
  Home,
  SupervisedUserCircle,
  Psychology,
  PeopleRounded,
  CalendarToday,
  Warehouse,
  CalendarMonth,
  MonetizationOn,
  Settings,
} from "@mui/icons-material";
import logo from "../../assets/logo.png";
import "./index.css";
import { useNavigate } from "react-router-dom";
import { PERFIS } from "../../constants/perfis";
import { useAuth } from "../../contexts/auth-context";
import { FaServicestack, FaUserPlus } from "react-icons/fa";



const ResponsiveMenu = () => {
  const navigate = useNavigate();
  const { user, logout, isAuthenticated } = useAuth();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [cadastroOpen, setCadastroOpen] = useState(false);
  const [agendamentoOpen, setAgendamentoOpen] = useState(false);
  const [configuracaoServicoOpen, setConfiguracaoServicoOpen] = useState(false);

  const toggleDrawer = () => setDrawerOpen(!drawerOpen);
  const toggleSubMenu = (setter) => () => setter((prev) => !prev);

  const menuItems = [
    { path: "/home", name: "Home", paddingLeft: 2, icon: <Home />, perfis: [PERFIS.ADMINISTRADOR, PERFIS.PROFISSIONAL] },
    ...(user?.profissionalExterno === false
      ? [{ path: "/meus-horarios", name: "Meus Horários", paddingLeft: 2, icon: <CalendarToday />, perfis: [PERFIS.PROFISSIONAL] }]
      : []),
    { path: "/fechamento", name: "Fechamento", paddingLeft: 2, icon: <MonetizationOn />, perfis: [PERFIS.ADMINISTRADOR, PERFIS.PROFISSIONAL] },
    { path: "/agenda", name: "Agenda", paddingLeft: 2, icon: <CalendarMonth />, perfis: [PERFIS.ADMINISTRADOR, PERFIS.PROFISSIONAL, PERFIS.AGENDAMENTO] },
  ];
  
  const agendamentosItems = [
    { path: "/agendar-salas", name: "Sala", paddingLeft: 5, icon: <Warehouse />, perfis: [PERFIS.ADMINISTRADOR, PERFIS.AGENDAMENTO] },
    { path: "/agendar-pacientes", name: "Paciente", paddingLeft: 5, icon: <PeopleRounded />, perfis: [PERFIS.ADMINISTRADOR, PERFIS.AGENDAMENTO] },
    { path: "/profissional-agenda", name: "Profissional", paddingLeft: 5, icon: <Psychology />, perfis: [PERFIS.ADMINISTRADOR, PERFIS.AGENDAMENTO] },
  ];
  
  const cadastroItems = [
    { path: "/lista-profissionais", name: "Profissional", paddingLeft: 5, icon: <Psychology />, perfis: [PERFIS.ADMINISTRADOR, PERFIS.AGENDAMENTO] },
    { path: "/lista-pacientes", name: "Paciente", paddingLeft: 5, icon: <PeopleRounded />, perfis: [PERFIS.ADMINISTRADOR, PERFIS.AGENDAMENTO] },
    { path: "/lista-usuarios", name: "Usuário", paddingLeft: 5, icon: <FaUserPlus />, perfis: [PERFIS.ADMINISTRADOR] },
    { path: "/lista-servicos", name: "Serviço", paddingLeft: 5, icon: <FaServicestack />, perfis: [PERFIS.ADMINISTRADOR] },
  ];
  
    const configuracaoServicoItems = [
      {path: '/configuracao-servicos', name: 'Serviços', paddingLeft: 5, icon: <MonetizationOn />, perfis: [PERFIS.ADMINISTRADOR] },
    ] 

  const handleLogout = () => {
    const confirmLogout = window.confirm("Deseja realmente sair?");
    if (confirmLogout) {
      logout();
      navigate("/login");
    }
  };

  const hasAccess = (requiredPerfis) => requiredPerfis.includes(user?.perfilId);

  const renderMenuItems = (items) =>
    items.map(
      (item) =>
        hasAccess(item.perfis) && (
          <ListItem
            button
            onClick={() => {
              navigate(item.path);
              setDrawerOpen(false);
            }}
            key={item.name}
            sx={{ pl: item.paddingLeft }}
          >
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.name} />
          </ListItem>
        )
    );

  return (
    <>
      <AppBar position="static" sx={{ backgroundColor: "#d9bcc1" }}>
        <Toolbar>
          {isAuthenticated &&
          <IconButton edge="start" color="inherit" onClick={toggleDrawer} aria-label="menu">
            <MenuIcon />
          </IconButton>
}
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            <img src={logo} alt="Núcleo Terapêutico Humanize" style={{ height: "40px", boxShadow: 10 }} />
          </Typography>
          {isAuthenticated && (
            <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
              <Typography variant="body1" component="span" sx={{ color: "black" }}>
                Olá, <b>{user?.nome.split(" ")[0] || "Usuário"}</b>
              </Typography>
              <Button color="inherit" startIcon={<Logout />} onClick={handleLogout}>
                Sair
              </Button>
            </div>
          )}
        </Toolbar>
      </AppBar>
      {isAuthenticated && (
        <Drawer
          anchor="left"
          open={drawerOpen}
          onClose={toggleDrawer}
          sx={{ "& .MuiDrawer-paper": { backgroundColor: "#d9bcc1" } }}
        >
          <List sx={{ width: 250 }}>
            {renderMenuItems(menuItems)}
            {hasAccess([PERFIS.ADMINISTRADOR, PERFIS.AGENDAMENTO]) && (
              <>
                <ListItem button onClick={toggleSubMenu(setAgendamentoOpen)}>
                  <ListItemIcon>
                    <CalendarToday />
                  </ListItemIcon>
                  <ListItemText primary="Agendamentos" />
                  {agendamentoOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={agendamentoOpen} timeout="auto" unmountOnExit>
                  {renderMenuItems(agendamentosItems)}
                </Collapse>
                <ListItem button onClick={toggleSubMenu(setCadastroOpen)}>
                  <ListItemIcon>
                    <SupervisedUserCircle />
                  </ListItemIcon>
                  <ListItemText primary="Cadastros" />
                  {cadastroOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={cadastroOpen} timeout="auto" unmountOnExit>
                  {renderMenuItems(cadastroItems)}
                </Collapse>
                <ListItem button onClick={toggleSubMenu(setConfiguracaoServicoOpen)}>
                  <ListItemIcon>
                    <Settings />
                  </ListItemIcon>
                  <ListItemText primary="Configurações" />
                  {configuracaoServicoOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={configuracaoServicoOpen} timeout="auto" unmountOnExit>
                  {renderMenuItems(configuracaoServicoItems)}
                </Collapse>
              </>
            )}
          </List>
        </Drawer>
      )}
    </>
  );
};

export default ResponsiveMenu;
